// extracted by mini-css-extract-plugin
export default {"pageContent":"App_pageContent__S6r43"};